import type { ProductPrices } from '../api/models';

export type TarifaKey = 'tarifa1' | 'tarifa7' | 'tarifa10' | 'tarifa12' | 'tarifa25';

export interface TarifaOption {
  value: number;
  key: TarifaKey;
  shortLabel: string;
  label: string;
  userFormTranslationKey?: string;
}

export const TARIFA_OPTIONS: TarifaOption[] = [
  {
    value: 1,
    key: 'tarifa1',
    shortLabel: 'Tarifa 1',
    label: 'Tarifa 1 - Retail/Minorista',
    userFormTranslationKey: 'admin.user_form.tariff1'
  },
  {
    value: 7,
    key: 'tarifa7',
    shortLabel: 'Tarifa 7',
    label: 'Tarifa 7 - Distribuidor Pequeno',
    userFormTranslationKey: 'admin.user_form.tariff7'
  },
  {
    value: 10,
    key: 'tarifa10',
    shortLabel: 'Tarifa 10',
    label: 'Tarifa 10'
  },
  {
    value: 12,
    key: 'tarifa12',
    shortLabel: 'Tarifa 12',
    label: 'Tarifa 12 - Distribuidor Mediano',
    userFormTranslationKey: 'admin.user_form.tariff12'
  },
  {
    value: 25,
    key: 'tarifa25',
    shortLabel: 'Tarifa 25',
    label: 'Tarifa 25 - Gran Distribuidor',
    userFormTranslationKey: 'admin.user_form.tariff25'
  }
];

export const NON_BASE_TARIFA_OPTIONS = TARIFA_OPTIONS.filter(({ key }) => key !== 'tarifa1');

const getFiniteNumber = (value: unknown) =>
  typeof value === 'number' && Number.isFinite(value) ? value : undefined;

export const createEmptyProductPrices = (baseValue = 0): ProductPrices => ({
  tarifa1: baseValue,
  tarifa7: 0,
  tarifa10: 0,
  tarifa12: 0,
  tarifa25: 0
});

export const normalizeProductPrices = (
  prices?: Partial<ProductPrices> | null,
  baseValue = 0
): ProductPrices => ({
  tarifa1: getFiniteNumber(prices?.tarifa1) ?? baseValue,
  tarifa7: getFiniteNumber(prices?.tarifa7) ?? 0,
  tarifa10: getFiniteNumber(prices?.tarifa10) ?? 0,
  tarifa12: getFiniteNumber(prices?.tarifa12) ?? 0,
  tarifa25: getFiniteNumber(prices?.tarifa25) ?? 0
});

export const getProductPriceByTarifa = (
  product: {
    prices?: ProductPrices;
    variants?: Array<{ prices?: ProductPrices }>;
  },
  tarifaKey: TarifaKey
): number => {
  const productPrice = product.prices?.[tarifaKey];
  if (typeof productPrice === 'number' && Number.isFinite(productPrice)) {
    return productPrice;
  }

  const variantPrice = product.variants?.[0]?.prices?.[tarifaKey];
  if (typeof variantPrice === 'number' && Number.isFinite(variantPrice)) {
    return variantPrice;
  }

  return 0;
};
